import { SaveAdjustmentPayload } from './../../../../models/adjustment';
import { AdjustmentService } from './../../../../shared/services/adjustments/adjustment.service';
import { requiredValidatorLogic } from './../../../../shared/directives/required.directive';
import { Utility } from './../../../../shared/utility';
import { ScheduleService } from './../../../../shared/services/pay-schedules/schedule.service';
import { UsersService } from './../../../../shared/services/common/users.service';
import { DisplayNotificationService } from './../../../../shared/services/common/notification.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-adj-record-add-edit-form',
  templateUrl: './adj-record-add-edit-form.component.html',
  styleUrls: ['./adj-record-add-edit-form.component.css']
})
export class AdjRecordAddEditFormComponent implements OnInit {
  isProcessing = false;
  isErr = false;
  isIssue = false;
  isConfirmOpened: boolean;
  scheduleSelected: boolean;
  scheduleDetailDialog: boolean;
  isInvalid: boolean;
  isStartDateValid = true;
  isEndDateValid = true;
  ssn: number;
  adjRecordId: number;
  gridData: any;
  selectedFYSchedules: any;
  fiscalYearGridData: any;
  scheduleEntry: any;
  adjModelDataItem: any;
  adjData: any;
  ssnNumber: any;
  selectedElements = [];

  recordErrors: any;
  recordIssues: any;
  config: any;
  noContectMsg: any;
  userLocations: any;
  userSystems: any;
  paySchedules: any;
  locationCode: any;
  systemCode: any;
  reasonCodesList: any;
  reasonCode = [];
  minDate = new Date();
  maxDate = new Date();
  payrollAdjId: any;
  min = 0.0;
  ssnMask = '000-00-0000';
  reviewFlag: boolean;
  ssnPattern = /^(?!666|000\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
  speCharPattern = /^[a-zA-Z\s.'\-,`]+$/;
  onlyNumberPattern = /^[0-9]*$/;
  selectableSettings: SelectableSettings = {
    enabled: true, checkboxOnly: true, mode: 'single'
  };
  addEditForm: UntypedFormGroup;
  personalDetailsForm: UntypedFormGroup;
  isRowSelected: (e: RowArgs) => boolean;

  isAdjEdit: boolean;
  isEditAdj: boolean;

  @Input() isNew = false;
  @Input() set adjustmentInputs(inputData: any) {
    if (inputData) {
      this.userLocations = inputData.locations;
      this.userSystems = inputData.systemCodes;
      this.paySchedules = inputData.payschedules;
      const newArray = inputData.reasonCodes.map(item => ({
        ...item,
        reasonCode: item.id + '-' + item.reason
      }));
      this.reasonCodesList = newArray;
    }
  }
  @Input() set configData(config: any) {
    if (config) {
      this.config = config;
    }
  }
  @Input() set model(record: any) {
    if (record) {
      this.adjData = this.isNew ? record : record.dataItem;
      this.ssnNumber = !this.isNew ? Utility.formatSSN(record.dataItem.ssn) : null;
      this.adjModelDataItem = record;
      this.isInvalid = record.isInvalid;
      this.reviewFlag = record.dataItem ? record.dataItem.review : false;
      // Todo change after discussion
      // if (record.isInvalid) {
      //   this.fiscalYearGridData = (record.fiscalYearScheduleList && record.fiscalYearScheduleList.schedules
      //     && record.fiscalYearScheduleList.schedules.length > 0) ? record.fiscalYearScheduleList.schedules : [];
      // }
      this.addEditRecord(record);
    }
  }
  @Input() set editModel(editRecord: any) {
    if (editRecord) {
      this.editInvalidAdjRecords(editRecord);
    }
  }
  @Output() saveResponse: EventEmitter<any> = new EventEmitter();
  @Output() closeAddEditForm: EventEmitter<any> = new EventEmitter();
  @Output() editInvalidAdj: EventEmitter<any> = new EventEmitter();

  constructor(
    private usersService: UsersService,
    private scheduleService: ScheduleService,
    private adjustmentService: AdjustmentService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit() {
    this.isRowSelected = (e: RowArgs) => this.selectedElements.indexOf(e.dataItem) >= 0;
  }

  getNewForm() {
    this.addEditForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      adjustmentImportId: new UntypedFormControl(''),
      fullSSN: new UntypedFormControl('', [Validators.required, Validators.pattern(this.ssnPattern)]),
      fiscalYear: new UntypedFormControl(''),
      firstName: new UntypedFormControl('', [Validators.required, Validators.pattern(this.speCharPattern)]),
      middleInitials: new UntypedFormControl(''),
      lastName: new UntypedFormControl('', [Validators.required, Validators.pattern(this.speCharPattern)]),
      locationCode: new UntypedFormControl('', [Validators.required]),
      systemCode: new UntypedFormControl('', [Validators.required]),
      reasonCode: new UntypedFormControl('', [Validators.required]),
      payPeriodEndDate: new UntypedFormControl('', [Validators.required, requiredValidatorLogic]),
      actualAnnualCompensation: new UntypedFormControl('', [Validators.required, Validators.pattern(this.onlyNumberPattern),
      Validators.min(0), Validators.max(this.config.maxAEC)]),
      actualEarnableCompensation: new UntypedFormControl('', [Validators.required, Validators.pattern(this.onlyNumberPattern),
      Validators.min(0), Validators.max(this.config.maxAEC)]),
      payPeriodBaseSalary: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(this.config.maxPBS)]),
      employeeContribution: new UntypedFormControl('', Validators.required),
      hoursWorked: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(288)]),
      standardHours: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(288)]),
      percentFullTime: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(100)])
    });
    if (this.isNew || this.isInvalid) {
      this.addEditForm.addControl('payPeriodStartDate', new UntypedFormControl('', [Validators.required, requiredValidatorLogic]));
    }
  }

  addEditRecord(record: any) {
    this.getNewForm();
    this.recordIssues = [];
    this.recordErrors = [];
    this.isErr = false;
    this.isIssue = false;
    if (record && record.dataItem && record.action === 'edit') {
      if (record && record.dataItem.error) {
        this.isErr = true;
        this.recordErrors = record.dataItem.error.split(',');
      }
      if (record.dataItem.issue) {
        this.isIssue = true;
        const issues = record.dataItem.issue.split(',');
        this.recordIssues = Utility.getIssues(issues);
      }
      this.adjRecordId = record.dataItem.id;
      this.locationCode = this.userLocations ? (this.userLocations.filter(x => x.code === record.dataItem.locationCode)[0]
        ? this.userLocations.filter(x => x.code === record.dataItem.locationCode)[0] : record.dataItem.locationCode) :
        this.userLocations[0];
      this.systemCode = this.userSystems ? this.userSystems.filter(x => x.code === record.dataItem.systemCode)[0] :
        this.userSystems[0];
      const codesArray = record.dataItem.reasonCodes ? record.dataItem.reasonCodes.split(',').map(Number) : '';
      this.reasonCode = this.reasonCodesList.filter(item => codesArray.includes(item.id));
      if (!record.isInvalid && record.dataItem.fiscalYear > 2016) {
        this.fiscalYearGridData = record.fiscalYearScheduleList.schedules.filter(x => x.id === record.dataItem.payScheduleId);
        this.fiscalYearGridData.forEach(element => {
          this.selectedElements.push(element);
        });
      }
      this.addEditForm.patchValue({
        fullSSN: record.dataItem.ssn,
        fiscalYear: record.dataItem.fiscalYear,
        firstName: record.dataItem.firstName,
        middleInitials: record.dataItem.middleInitials,
        lastName: record.dataItem.lastName,
        locationCode: this.locationCode,
        systemCode: this.systemCode,
        reasonCode: this.reasonCode,
        payPeriodStartDate: record.dataItem.payPeriodBeginningDate,
        payPeriodEndDate: record.dataItem.payPeriodEndDate,
        actualAnnualCompensation: record.dataItem.actualAnnualCompensation,
        actualEarnableCompensation: record.dataItem.actualEarnableCompensation,
        payPeriodBaseSalary: record.dataItem.payPeriodBaseSalary,
        employeeContribution: record.dataItem.employeeContribution,
        hoursWorked: record.dataItem.hoursWorked,
        standardHours: record.dataItem.standardHours,
        percentFullTime: record.dataItem.percentFullTime,
      });
      this.addEditForm.controls['fullSSN'].disable();
      this.addEditForm.controls['fiscalYear'].disable();
      this.addEditForm.controls['firstName'].disable();
      this.addEditForm.controls['middleInitials'].disable();
      this.addEditForm.controls['lastName'].disable();
      if (!record.isInvalid) {
        this.addEditForm.controls['payPeriodEndDate'].disable();
        this.fiscalYearDateRange();
      } else {
        this.fiscalYearDateRange();
        // TODO set the min and max date after discussion with Harris
        this.addEditForm.patchValue({ payPeriodStartDate: null });
        this.addEditForm.patchValue({ payPeriodEndDate: null });
        this.addEditForm.controls['payPeriodStartDate'].disable();
        this.addEditForm.controls['payPeriodEndDate'].disable();
      }
      this.scheduleSelected = true;
    } else {
      this.isErr = false;
      this.locationCode = this.userLocations ? this.userLocations.filter(x => x.code === record.location)[0] :
        this.userLocations[0];
      this.systemCode = this.userSystems ? this.userSystems.filter(x => x.code === record.system)[0] :
        this.userSystems[0];
      this.fiscalYearGridData = (record.fiscalYearScheduleList && record.fiscalYearScheduleList.schedules
        && record.fiscalYearScheduleList.schedules.length > 0) ? record.fiscalYearScheduleList.schedules : [];
      this.addEditForm.patchValue({
        fullSSN: record.fullSSN,
        fiscalYear: record.fiscalYear,
        firstName: record.firstName,
        middleInitials: record.mi,
        lastName: record.lastName,
        locationCode: this.locationCode,
        systemCode: this.systemCode,
      });
      this.addEditForm.controls['fullSSN'].disable();
      this.addEditForm.controls['fiscalYear'].disable();
      this.addEditForm.controls['firstName'].disable();
      this.addEditForm.controls['middleInitials'].disable();
      this.addEditForm.controls['lastName'].disable();
      if (record && record.fiscalYear > 2016) {
        this.addEditForm.controls['payPeriodStartDate'].disable();
        this.addEditForm.controls['payPeriodEndDate'].disable();
      } else {
        this.addEditForm.controls['payPeriodStartDate'].enable();
        this.addEditForm.controls['payPeriodEndDate'].enable();
      }
      // Todo change after discussion
      this.fiscalYearDateRange();
    }
    this.payrollAdjId = this.isNew ? record.adjustmentImportId : record.dataItem.payrollAdjustmentsId;
  }

  editInvalidAdjRecords(record: any) {
    this.adjData = record;
    this.adjModelDataItem = record;
    this.isStartDateValid = true;
    this.addEditForm.patchValue({ payPeriodStartDate: null });
    this.addEditForm.patchValue({ payPeriodEndDate: null });
    if (record.fiscalYear > 2016) {
      this.addEditForm.controls['payPeriodStartDate'].disable();
      this.addEditForm.controls['payPeriodEndDate'].disable();
    } else {
      this.addEditForm.controls['payPeriodStartDate'].enable();
      this.addEditForm.controls['payPeriodEndDate'].enable();
    }
    this.ssnNumber = Utility.formatSSN(record.fullSSN);
    this.locationCode = this.userLocations ? (this.userLocations.filter(x => x.code === record.location)[0]
      ? this.userLocations.filter(x => x.code === record.location)[0] : record.location) :
      this.userLocations[0];
    this.systemCode = this.userSystems ? this.userSystems.filter(x => x.code === record.system)[0] :
      this.userSystems[0];
    this.fiscalYearGridData = (record.fiscalYearScheduleList && record.fiscalYearScheduleList.schedules
      && record.fiscalYearScheduleList.schedules.length > 0) ? record.fiscalYearScheduleList.schedules : [];
    this.isEditAdj = true;
    this.addEditForm.patchValue({
      fullSSN: record.fullSSN,
      fiscalYear: record.fiscalYear,
      firstName: record.firstName,
      middleInitials: record.mi,
      lastName: record.lastName,
      locationCode: this.locationCode,
      systemCode: this.systemCode,
      reasonCode: this.reasonCode
    });
    this.addEditForm.controls['reasonCode'].setErrors(null);
  }

  onSelectionChange(event: any) {
    if (event.selectedRows.length > 0) {
      this.scheduleSelected = true;
      event.selectedRows[0].dataItem.isScheduleSelected = true;
      this.addEditForm.controls['payPeriodStartDate'].enable();
      this.addEditForm.controls['payPeriodEndDate'].enable();
      this.addEditForm.patchValue({ payrollSchedule: event.selectedRows[0].dataItem.id });
      this.fiscalYearDateRange();
      this.selectedElements.push(event.selectedRows[0].dataItem);
    }
    if (event.deselectedRows.length > 0) {
      event.deselectedRows[0].dataItem.isScheduleSelected = false;
      const index = this.selectedElements.indexOf(event.deselectedRows[0].dataItem);
      this.selectedElements.splice(index, 1);
    }
    if (this.selectedElements.length === 0) {
      this.scheduleSelected = false;
      this.isStartDateValid = true;
      this.isEndDateValid = true;
      this.addEditForm.patchValue({ payPeriodStartDate: null });
      this.addEditForm.patchValue({ payPeriodEndDate: null });
      this.addEditForm.controls['payPeriodStartDate'].disable();
      this.addEditForm.controls['payPeriodEndDate'].disable();
    }
  }

  editClick(formData: any, flag: boolean) {
    this.isAdjEdit = flag;
    this.editInvalidAdj.emit(flag);
  }

  onCodeChange(e: any, name: string) {
    if (e && e.length > 0) {
      this.addEditForm.controls[name].patchValue(e);
      this.addEditForm.controls[name].setErrors(null);
    }
  }

  fiscalYearDateRange() {
    const fiscalYear = Number(this.addEditForm.getRawValue().fiscalYear);
    this.minDate = new Date(fiscalYear - 1, 6, 1);
    this.maxDate = new Date(fiscalYear, 5, 30);
  }

  trimContent(data: any) {
    if (data.target.value) {
      const replaceInput = data.target.value.replace(/[^a-zA-Z]/g, '');
      this.addEditForm.controls.middleInitials.setValue(replaceInput);
    }
  }

  onLocSysChanges(e: any, name: string) {
    const id = e.id ? e.id : e.code;
    this.addEditForm.controls[name].patchValue(id);
  }

  setIntMaxVal(name) {
    if (this.addEditForm.get(name).value) {
      let value = this.addEditForm.get(name).value.toString();
      if (value.length > this.config.charLimit) {
        value = value.substr(0, this.config.charLimit);
      }
      const setValue = parseInt(value, 0);
      this.addEditForm.controls[name].setValue(setValue);
    }
  }

  setDecMaxVal(name) {
    if (this.addEditForm.get(name).value) {
      let value = this.addEditForm.get(name).value.toString();
      const char = name === 'employeeContribution' ? this.config.contrCharLimit : this.config.baseSalCharLimit;
      if (value.length > char) {
        value = value.substr(0, char);
        this.addEditForm.controls[name].setValue(parseFloat(value));
      }
    }
  }

  onCancel(formData: any): void {
    if (formData.dirty || this.isNew ? this.selectedElements.length > 0 : false) {
      this.isConfirmOpened = true;
    } else {
      this.isConfirmOpened = false;
      this.close();
    }
  }

  close() {
    this.selectedElements = [];
    this.isConfirmOpened = false;
    const payrollAdjId = this.isNew ? ((this.adjModelDataItem && this.adjModelDataItem.adjustmentImportId)
      ? this.adjModelDataItem.adjustmentImportId : 0) : this.payrollAdjId;
    this.closeAddEditForm.emit({ payrollAdjustmentsId: payrollAdjId });
    this.addEditForm = null;
  }

  onSave(e: any) {
    this.notificationService.setUpLoading(true);
    this.isProcessing = true;
    const adjInputData = this.prepareInputData(this.isNew);
    const inputData = { userInfo: this.usersService.UserInfo(), adjustment: adjInputData };
    this.adjustmentService.saveAdjustmentRecord(inputData, this.isNew)
      .subscribe(response => {
        if (response && response.statusCode === 200) {
          if (!this.isNew) {
            response.payrollAdjustmentsId = this.payrollAdjId;
          }
          this.saveResponse.emit(response);
        } else {
          this.notificationService.setErrorNotification();
        }
        this.isProcessing = false;
        this.notificationService.setUpLoading(false);
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.isProcessing = false;
          this.notificationService.setErrorNotification();
          this.notificationService.setUpLoading(false);
        });
  }

  prepareInputData(isNew: boolean) {
    const adjustmentFormData = new SaveAdjustmentPayload();
    const record = this.addEditForm.getRawValue();
    const additionalData = this.selectedElements[0];
    const reasonCodes = record.reasonCode.map(item => item.id).join(',');
    adjustmentFormData.payrollAdjustmentsId = this.payrollAdjId ? this.payrollAdjId : 0;
    adjustmentFormData.ssn = record.fullSSN;
    adjustmentFormData.firstName = record.firstName;
    adjustmentFormData.lastName = record.lastName;
    adjustmentFormData.middleInitials = record.middleInitials;
    adjustmentFormData.systemCode = record.systemCode.code;
    adjustmentFormData.locationCode = record.locationCode.code;
    adjustmentFormData.reasonCodes = reasonCodes;
    adjustmentFormData.actualAnnualCompensation = record.actualAnnualCompensation;
    adjustmentFormData.employeeContribution = record.employeeContribution;
    adjustmentFormData.hoursWorked = record.hoursWorked;
    adjustmentFormData.standardHours = record.standardHours;
    adjustmentFormData.percentFullTime = record.percentFullTime;
    adjustmentFormData.payPeriodBaseSalary = record.payPeriodBaseSalary;
    adjustmentFormData.actualEarnableCompensation = record.actualEarnableCompensation;
    adjustmentFormData.payScheduleId = (this.adjModelDataItem && this.adjModelDataItem.fiscalYear > 2016) ? additionalData.id : null;
    if (isNew) {
      adjustmentFormData.ppedstart = record.payPeriodStartDate;
      adjustmentFormData.ppedend = record.payPeriodEndDate;
    } else {
      adjustmentFormData.id = this.adjRecordId;
      adjustmentFormData.payPeriodBeginningDate = this.isInvalid ? record.payPeriodStartDate : this.adjModelDataItem.dataItem.payPeriodBeginningDate;
      adjustmentFormData.payPeriodEndDate = record.payPeriodEndDate;
      adjustmentFormData.review = this.isInvalid ? this.reviewFlag : this.adjModelDataItem.dataItem.review;
    }
    return adjustmentFormData;
  }

  onStartDateChange(value: any) {
    if (this.adjModelDataItem && this.adjModelDataItem.fiscalYear > 2016) {
      if ((value && value.valueOf() > 0 && value >= this.minDate && value <= this.maxDate)) {
        if (this.addEditForm.value.payPeriodEndDate && value > this.addEditForm.value.payPeriodEndDate) {
          this.isStartDateValid = false;
        } else {
          this.isStartDateValid = true;
          this.isEndDateValid = true;
          this.scheduleSelected = true;
          if (this.reasonCode.length > 0) {
            this.addEditForm.controls['reasonCode'].setErrors(null);
          }
        }
      } else {
        this.isStartDateValid = false;
      }
    } else {
      this.isStartDateValid = true;
      this.scheduleSelected = true;
      if (this.reasonCode.length > 0) {
        this.addEditForm.controls['reasonCode'].setErrors(null);
      }
    }
  }

  onEndDateChange(value: any) {
    if (this.adjModelDataItem && this.adjModelDataItem.fiscalYear > 2016) {
      if ((value && value.valueOf() > 0 && value >= this.minDate && value <= this.maxDate)) {
        if (this.addEditForm.value.payPeriodStartDate && value < this.addEditForm.value.payPeriodStartDate) {
          this.isEndDateValid = false;
        } else {
          this.isEndDateValid = true;
          this.isStartDateValid = true;
          this.scheduleSelected = true;
          if (this.reasonCode.length > 0) {
            this.addEditForm.controls['reasonCode'].setErrors(null);
          }
        }
      } else {
        this.isEndDateValid = false;
      }
    } else {
      this.isEndDateValid = true;
      this.scheduleSelected = true;
      if (this.reasonCode.length > 0) {
        this.addEditForm.controls['reasonCode'].setErrors(null);
      }
    }
  }

  loadScheduleDetails(dataItem: any) {
    const obj = { userInfo: this.usersService.UserInfo(), id: dataItem.id };
    this.scheduleService.getScheduleEntries(obj).subscribe(response => {
      dataItem.isClicked = !dataItem.isClicked;
      if (response && response.success && response.message.length > 0) {
        this.scheduleEntry = response.message;
        this.scheduleDetailDialog = true;
      } else {
        this.notificationService.setErrorNotification();
      }
      this.isProcessing = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        dataItem.isClicked = !dataItem.isClicked;
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      });
  }

}
